export const DEFAULT_KNOWLEDGE_EVENT_IMAGE = "/ImageAndVideo/image/RemoteHealth.jpg";

const firstNonEmpty = (...values) =>
  values.find(
    (value) => value !== undefined && value !== null && String(value).trim() !== ""
  );

const getItems = (response) => {
  if (Array.isArray(response)) return response;
  if (Array.isArray(response?.Data)) return response.Data;
  if (Array.isArray(response?.data)) return response.data;
  if (Array.isArray(response?.items)) return response.items;
  if (Array.isArray(response?.Items)) return response.Items;
  return [];
};

const toEventId = (item, index) =>
  item?.eventId ??
  item?.EventId ??
  item?.knowledgeCenterId ??
  item?.KnowledgeCenterId ??
  item?.id ??
  item?.Id ??
  `event-${index}`;

export const buildKnowledgeEventImageUrl = (imagePath, baseUrl = "") => {
  if (!imagePath) return DEFAULT_KNOWLEDGE_EVENT_IMAGE;

  const normalizedPath = String(imagePath).trim().replace(/\\/g, "/");
  if (!normalizedPath) return DEFAULT_KNOWLEDGE_EVENT_IMAGE;

  if (/^https?:\/\//i.test(normalizedPath)) {
    return normalizedPath;
  }

  if (!baseUrl) {
    return normalizedPath;
  }

  const normalizedBaseUrl = baseUrl.endsWith("/") ? baseUrl : `${baseUrl}/`;
  const pathWithoutLeadingSlash = normalizedPath.startsWith("/")
    ? normalizedPath.slice(1)
    : normalizedPath;

  return new URL(pathWithoutLeadingSlash, normalizedBaseUrl).toString();
};

const toEventDate = (item) =>
  item?.eventDate ??
  item?.EventDate ??
  item?.date ??
  item?.Date ??
  "";

export const normalizeKnowledgeEvents = (response, baseUrl = "") =>
  getItems(response).map((item, index) => ({
    id: toEventId(item, index),
    title: item?.title ?? item?.Title ?? "",
    description: item?.description ?? item?.Description ?? "",
    eventDate: toEventDate(item),
    imagePath: firstNonEmpty(
      item?.ImagePath,
      item?.imagePath,
      item?.ImageUrl,
      item?.imageUrl,
      item?.Image,
      item?.image,
      item?.Photo,
      item?.photo
    ),
    image: buildKnowledgeEventImageUrl(
      firstNonEmpty(
        item?.ImagePath,
        item?.imagePath,
        item?.ImageUrl,
        item?.imageUrl,
        item?.Image,
        item?.image,
        item?.Photo,
        item?.photo
      ),
      baseUrl
    ),
    raw: item,
  }));

export const formatKnowledgeEventDate = (value) => {
  if (!value) return "-";

  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return String(value);

  return date.toLocaleString();
};
